module.exports = new __parcel__URL__("closed-hihat_12.b1e4a2bf.mp3").toString();